import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Star, MessageSquare } from 'lucide-react';

const CookingFeedbackDialog = ({ show, onHide, onSubmit, recipeTitle }) => {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");
    const [hoveredStar, setHoveredStar] = useState(0);

    const handleSubmit = () => {
        onSubmit({ rating, comment, cookedAt: new Date().toISOString() });
        // Reset
        setRating(0);
        setComment("");
        setHoveredStar(0);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} centered contentClassName="rounded-4 border-0 shadow-lg">
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="fw-bold">Gekocht!</Modal.Title>
            </Modal.Header>
            <Modal.Body className="px-4 pb-4">
                <div className="text-center mb-4">
                    <h5 className="mb-3">Wie hat dir <span className="text-primary">"{recipeTitle}"</span> geschmeckt?</h5>

                    <div className="d-flex justify-content-center gap-2 mb-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <Star
                                key={star}
                                size={32}
                                className={`cursor-pointer transition-all ${(hoveredStar || rating) >= star
                                        ? "fill-warning text-warning"
                                        : "text-muted opacity-25"
                                    }`}
                                onMouseEnter={() => setHoveredStar(star)}
                                onMouseLeave={() => setHoveredStar(0)}
                                onClick={() => setRating(star)}
                                fill={(hoveredStar || rating) >= star ? "currentColor" : "none"}
                            />
                        ))}
                    </div>
                    <div className="small text-muted fw-bold">
                        {rating > 0 ? (rating === 5 ? "Fantastisch!" : rating === 4 ? "Sehr gut" : rating === 3 ? "Gut" : "Geht so") : "Bewerten"}
                    </div>
                </div>

                <div className="mb-3">
                    <label className="form-label small fw-bold text-muted text-uppercase d-flex align-items-center gap-2">
                        <MessageSquare size={14} /> Dein Kommentar (optional)
                    </label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Was hat dir besonders gut gefallen? Was hast du verändert?"
                        className="bg-light border-0"
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />
                </div>

                <Button
                    variant="primary"
                    size="lg"
                    className="w-100 rounded-pill fw-bold shadow-sm"
                    disabled={rating === 0}
                    onClick={handleSubmit}
                >
                    Speichern
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default CookingFeedbackDialog;
